import React, { useEffect, useState } from "react";
import {
  Container, Card, CardBody, Table, Badge, Spinner, Row, Col,
} from "reactstrap";
import { Link } from "react-router-dom";
import { getAllSupportMembers } from "../../../helpers/firestoreService";
import { useAuthUser } from "../../../hooks/AuthProvider";
import homeBg from "../../../assets/images/home.png";

const SupportMemberList = () => {
  document.title = "Support Members | Support Portal";

  const user = useAuthUser();
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    (async () => {
      try {
        const m = await getAllSupportMembers(user.uid);
        setMembers(m);
      } catch (e) {
        console.error("Failed to load support members:", e);
      } finally {
        setLoading(false);
      }
    })();
  }, [user]);

  if (loading) {
    return (
      <div className="page-content text-center py-5">
        <Spinner color="primary" />
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        {/* ── Hero Banner ──────────────────────────────────────────────────── */}
        <div className="rounded mb-4 p-4 text-white position-relative overflow-hidden" style={{ minHeight: 180 }}>
          <div style={{ position: "absolute", inset: 0, backgroundImage: `url(${homeBg})`, backgroundSize: "cover", backgroundPosition: "center", opacity: 0.18 }} />
          <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg, #556ee6 0%, #34c38f 100%)" }} />
          <div className="position-relative" style={{ zIndex: 1 }}>
            <Row className="align-items-center">
              <Col>
                <h3 className="mb-1 text-white">Support Members</h3>
                <p className="mb-0 opacity-75">
                  All support members across your portals. Add support members from{" "}
                  portal settings.
                </p>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col xs="auto">
                <Badge color="light" className="text-dark fs-6 px-3 py-2">
                  <i className="bx bx-user me-1" />
                  {members.length} Member{members.length !== 1 ? "s" : ""}
                </Badge>
              </Col>
            </Row>
          </div>
        </div>

        {members.length === 0 ? (
          <Card>
            <CardBody className="text-center py-5">
              <i className="bx bx-group text-muted" style={{ fontSize: "2.5rem" }} />
              <h5 className="text-muted mt-2">No support members yet</h5>
              <p className="text-muted">
                Support members are added via portal settings. Go to a portal and add
                support member emails to see them here.
              </p>
            </CardBody>
          </Card>
        ) : (
          <Card>
            <CardBody>
              <div className="table-responsive">
                <Table className="table-hover mb-0">
                  <thead>
                    <tr>
                      <th>Email</th>
                      <th>Portals</th>
                      <th># Portals</th>
                    </tr>
                  </thead>
                  <tbody>
                    {members.map((m) => (
                      <tr key={m.email}>
                        <td>
                          <i className="bx bx-user me-1 text-muted" />
                          {m.email}
                        </td>
                        <td>
                          <div className="d-flex flex-wrap gap-1">
                            {m.portalNames.map((name, idx) => (
                              <Link
                                key={m.portalIds[idx]}
                                to={`/portals/${m.portalIds[idx]}`}
                              >
                                <Badge color="primary" className="fw-normal">
                                  {name}
                                </Badge>
                              </Link>
                            ))}
                          </div>
                        </td>
                        <td>
                          <Badge color="secondary">{m.portalIds.length}</Badge>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </CardBody>
          </Card>
        )}
      </Container>
    </div>
  );
};

export default SupportMemberList;
